import { render, staticRenderFns } from "./Kits.vue?vue&type=template&id=7b255fee"
import script from "./Kits.vue?vue&type=script&lang=js"
export * from "./Kits.vue?vue&type=script&lang=js"
import style0 from "./Kits.vue?vue&type=style&index=0&id=7b255fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports